import { render, staticRenderFns } from "./ConfigUsuariosEditar.vue?vue&type=template&id=2cea8fe4&scoped=true&lang=pug&"
import script from "./ConfigUsuariosEditar.vue?vue&type=script&lang=js&"
export * from "./ConfigUsuariosEditar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUsuariosEditar.vue?vue&type=style&index=0&id=2cea8fe4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea8fe4",
  null
  
)

export default component.exports